import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-metro4",
  "use": "icon-metro4-usage",
  "viewBox": "0 0 1027 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1027 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-metro4\"><defs><style type=\"text/css\"></style></defs><path d=\"M451.249274 127.359125h-2.922197a448.313862 448.313862 0 1 0 448.313862 448.070346H451.249274z\" fill=\"#4A81FF\" p-id=\"9908\" /><path d=\"M1027.165779 440.521335H580.313015V0h6.331429a440.521335 440.521335 0 0 1 440.521335 440.521335z\" fill=\"#4A81FF\" p-id=\"9909\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol